import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {TodayGiftListResultVo} from '../../common/shared/api/nicolas/vo/TodayGiftListResultVo.interface';
import {trimUndefinedFromObject} from '../../common/util/trimUndefinedFromObject';
import type {TodayGiftListQueryVariables} from '../../graphql/generated/types';

/**
 * 오늘의 선물 목록 조회
 *
 * Origin: pageNicolasApi.getTodayGiftList
 * API: GET /api/v8/store/today_gift/list
 */
export async function getStoreTodayGiftList(
  {categoryUid, subCategoryUid}: TodayGiftListQueryVariables = {},
  options?: FetcherOptions
): Promise<ApiResultVo & {result?: TodayGiftListResultVo}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v8/store/today_gift/list',
    {
      method: 'GET',
      params: trimUndefinedFromObject({
        category_uid: categoryUid,
        subcategory_uid: subCategoryUid,
      }),
    },
    options
  );

  return response.data;
}
